import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import baseMessage from '@/views/yuntuSales/marketing/partnerManage/components/baseMessage.vue'
import contactsTable from '@/views/yuntuSales/marketing/partnerManage/components/contactsTable.vue'
import partnerActivity from '@/views/yuntuSales/marketing/partnerManage/components/partnerActivity.vue'
import partnerFollowRecord from '@/views/yuntuSales/marketing/partnerManage/components/partnerFollowRecord.vue'

const __default__ = { name: 'DcCosLbuPartnerManageView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permissionBase = {
  edit: 'lbu_partner_counterpart_edit_btn'
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        view: "",
                        content: ['partnerBase'],
                        permissionPage: permissionBase
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "对接人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(contactsTable)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: "市场活动"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(partnerActivity)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    tab: "维护记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(partnerFollowRecord)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})